import { DocumentIsogd } from "isogd-document-rest";

class DocumentObjectViewController {
    private document: DocumentIsogd;
}

export const DocumentObjectViewComponent: angular.IComponentOptions = {
    controller: DocumentObjectViewController,
    template: require('./documentObjectView.html'),
    bindings: {
        document: "<"
    }
};


// WEBPACK FOOTER //
// ./src/components/document/document-object/documentObjectView.ts